export default "__VITE_ASSET__cfda1dac__"